import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
// Instala la cabecera X-CSRF-Token en la instancia por defecto de axios antes
// de que nada pueda usarla: `subir-archivo.js`, `AdminHomeEditor` y
// `AdminPageEditor` guardan con esa instancia. Ver `@/lib/csrf`.
import "@/lib/csrf";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
